import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { FloatingAlertsService } from '@shared/components/floating-alerts/data/floating-alerts.service';
import { FloatingAlertComponent } from '@shared/components/floating-alerts/ui/floating-alert/floating-alert.component';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'ac-floating-alerts-container',
  standalone: true,
  imports: [FloatingAlertComponent],
  templateUrl: './floating-alerts-container.component.html',
  styleUrls: ['./floating-alerts-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ transform: 'translateX(100%)', 'max-height': 0 }),
        animate('.5s ease-out', style({ transform: 'translateX(0)', 'max-height': '200px' })),
      ]),
      transition(':leave', [
        style({ transform: 'translateX(0)', 'max-height': '200px' }),
        animate('.5s ease-out', style({ transform: 'translateX(-100%)', 'max-height': 0 })),
      ]),
    ]),
  ],
  host: {
    '[class.empty]': '_emptyList()',
  },
})
export class FloatingAlertsContainerComponent {
  protected readonly _listSig = this._floatingAlertsService.list;
  protected readonly _emptyList = computed(() => this._listSig().length === 0);
  constructor(private _floatingAlertsService: FloatingAlertsService) {}
}
